import { parseDate, isAfter } from 'shared-components';

export const getLateArrivals = (travelBookedDate: string, lastAcceptanceDate: string, hasAccess = true) => {
  // Check if travelBookedDate exists and has the expected format
  if (!travelBookedDate || !travelBookedDate.includes('-')) {
    return false;
  }

  // Convert DD-MM-YYYY to ISO format for parseDate
  const dateParts = travelBookedDate.split('-');
  if (dateParts.length !== 3) {
    return false;
  }

  const [day, month, year] = dateParts;
  // Ensure all parts exist before calling padStart
  if (!day || !month || !year) {
    return false;
  }

  const isoTravelDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

  const parsedTravelDate = parseDate(isoTravelDate);
  const parsedAcceptanceDate = parseDate(lastAcceptanceDate);

  return (
    !!lastAcceptanceDate &&
    hasAccess &&
    parsedTravelDate &&
    parsedAcceptanceDate &&
    isAfter(parsedTravelDate, parsedAcceptanceDate)
  );
};
